<template>
  <div class="qa-list">
    <div class="quiz" @click="goQa">
      <div class="qa-btn">向ta提问</div>
    </div>
    <!-- 问答列表 -->
    <HomeList
      v-if="isShowList"
      :getListApi="getbusinesses"
      :params="homeListParams"
    >
      <template>
        <QaItem
          v-for="(item, index) in qaList"
          :key="index"
          :qaInfo="item"
          @goAnswerDes="goAnswerDes"
          @goQuestionDes="goQuestionDes"
        ></QaItem>
      </template>
    </HomeList>
  </div>
</template>
<script>
import HomeList from 'component/platform/homepage/common/homeList.vue'
import QaItem from 'component/platform/homepage/normalUser/qaItem.vue'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
import { getUserInviteNum } from 'api/platform/homepage.js'
export default {
  name: 'qaList',
  mixins: [homepageMixin],
  props: {},
  components: {
    HomeList,
    QaItem
  },
  data() {
    return {
      homeListParams: {},
      isShowList: false
    }
  },
  computed: {
    qaList() {
      return this.$store.getters['homepage/getTabListData']('qa') || []
    }
  },
  created() {},
  mounted() {
    // 获取token, 再发起请求
    this.mixinGetToken().then(token => {
      this.token = token
      this.homeListParams = {
        user_id: this.$route.params.userId,
        token: token,
        business_type: 'qa'
      }
      this.isShowList = true
    })
  },
  methods: {
    getbusinesses(params) {
      return this.$store.dispatch('homepage/fetchBusinesses', params)
    },
    goAnswerDes() {
      this.$trackEvent('newprofilepages_ask_answerclick', {})
    },
    goQuestionDes() {
      this.$trackEvent('newprofilepages_ask_questionclick', {})
    },
    // 获取问答积分
    getUserInviteNum() {
      getUserInviteNum({
        user_id: this.$route.params.userId,
        token: this.token
      }).then(({ code, data }) => {
        if (+code === 0) {
          if (+data.invite_num > 0) {
            this.routerPush(
              `https://m.xinli001.com/qa/post-question-view?invite_user=${this.$route.params.userId}`
            )
          } else {
            this.$toast(
              '你的邀答次数已用完! 分享问题或回答，每天可以获得1次邀答次数'
            )
          }
        }
      })
    },
    // 跳转提问
    goQa() {
      this.$trackEvent('newprofilepages_ask_askta', {})
      this.getUserInviteNum()
    }
  }
}
</script>
<style lang="scss" scoped>
.quiz {
  margin: 30px 0;
  .qa-btn {
    width: 686px;
    height: 80px;
    margin: 0 auto;
    background: linear-gradient(180deg, #bdc9fd 0%, #5d70f9 100%);
    border-radius: 40px;
    line-height: 80px;
    text-align: center;
    font-size: 32px;
    font-weight: 600;
    color: #fff;
  }
}
</style>
